
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"26","height":"26","viewBox":"0 0 22.099 15.802"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Контур 521","d":"M1.324 14.48a4.241 4.241 0 005.349-1.893c2.033-3.227 4.313-12.71 6.918-5.713 2.964 8.316 5.118 3.865 7.309-5.676","fill":"none","stroke":"#f70","stroke-linecap":"round","stroke-width":"2"}})])
          )
        }
      }
    